export default __webpack_public_path__ + "static/drifter2-4332c698d59b63743523cd70badc6e09.jpg";